/* eslint-disable import/no-unresolved */
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import ReactDOM from 'react-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { clear } from 'idb-keyval';
import { node } from 'prop-types';

import { SDPProvider } from 'Contexts';
import { Keycloak } from 'Services';

import { LoadingComponent } from 'Components';

import App from './App';
import useRoutes from './Routes/useRoutes';

import 'Styles/index.scss';

function KCProvider({ children }) {
  const { unauthorizedPaths } = useRoutes();

  return (
    <ReactKeycloakProvider
      authClient={Keycloak}
      initOptions={
        unauthorizedPaths?.indexOf(window.location.pathname) > -1
          ? { checkLoginIframe: false }
          : { onLoad: 'login-required', checkLoginIframe: false }
      }
      LoadingComponent={<LoadingComponent />}
      onEvent={(e) => {
        if (e === 'onAuthLogout') {
          clear();
          localStorage.clear();
        }
      }}
    >
      {children}
    </ReactKeycloakProvider>
  );
}

KCProvider.propTypes = {
  children: node.isRequired
};

ReactDOM.render(
  <React.StrictMode>
    <KCProvider>
      <SDPProvider>
        <App />
        <Toaster />
        <HelmetProvider>
          <Helmet>
            {process.env.REACT_APP_HORIZON_ASSISTANTE && (
              <script src={process.env.REACT_APP_HORIZON_ASSISTANTE} />
            )}
          </Helmet>
        </HelmetProvider>
      </SDPProvider>
    </KCProvider>
  </React.StrictMode>,
  document.querySelector('#root')
);
